<script>
import forminput from "../formcomponet/forminput.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznisilanlari from "@/models/mznisilanlari";
import formcombobox from "../formcomponet/formcombobox.vue";
import formdate from "../formcomponet/formdate.vue";

export default {
  mixins: [apibtoast, apigeneric, mznisilanlari],
  props: ["Id", "AddEdit","Firmaid"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formtextarea,
    formcombobox,
    formdate

  },
  watch: {
     Id() {
      this.FormData = this.Id;
      this.FormData.Firmaid = this.Firmaid
    }   
  },
  created() {

    
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {

          this.Post(this.$config.API_URL_2+"mznisilanlari", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("mznisilanlari");
            }
          });
        } else {

          this.Update(this.$config.API_URL_2+"mznisilanlari", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("mznisilanlari");
            }
          });
        }
      }
    },
  }
  
};
</script>
<template>
  <Loader>
    <b-modal
      id="mznisilanlari"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('mznisilanlari.AddEdit.FormTitleEdit')
          : $t('mznisilanlari.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <br>
      <Form @submit.prevent="onSubmit"> 
         <div class="row">
          <div class="col-md-6 mt-5">
            <formcombobox
              :FormDataType="FormDataType.Calismasekli"
              :Value="FormData.Calismasekli"
              :v="$v.FormData.Calismasekli"
              @input="FormData.Calismasekli = $event" 
              />
          </div>
          <div class="col-md-6 mt-5">
            <formcombobox
              :FormDataType="FormDataType.Istipi"
              :Value="FormData.Istipi"
              :v="$v.FormData.Istipi"
              @input="FormData.Istipi = $event"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Sektor"
              :Value="FormData.Sektor"
              :v="$v.FormData.Sektor"
              @input="FormData.Sektor = $event"
            />
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Pozisyon"
              :Value="FormData.Pozisyon"
              :v="$v.FormData.Pozisyon"
              @input="FormData.Pozisyon = $event"
            />
          </div>
        </div>
         <div class="row">
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Departman"
              :Value="FormData.Departman"
              :v="$v.FormData.Departman"
              @input="FormData.Departman = $event"
            />
          </div>
  <!--      <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Tecrube"
              :Value="FormData.Tecrube"
              :v="$v.FormData.Tecrube"
              @input="FormData.Tecrube = $event"
            />
          </div>  
             <div class="col-md-6">
            <formcombobox
                  :FormDataType="FormDataType.Askerlikdurumu"
                  :Value="FormData.Askerlikdurumu"
                  :v="$v.FormData.Askerlikdurumu"
                  @input="FormData.Askerlikdurumu = $event"
                />
          </div> 
        </div>
         <div class="row">
               <div class="col-md-6">
            <formcombobox
                  :FormDataType="FormDataType.Cinsiyet"
                  :Value="FormData.Cinsiyet"
                  :v="$v.FormData.Cinsiyet"
                  @input="FormData.Cinsiyet = $event"
                />
          </div>
          <div class="col-md-6">
           <formcombobox
                  :FormDataType="FormDataType.Ehliyet"
                  :Value="FormData.Ehliyet"
                  :v="$v.FormData.Ehliyet"
                  @input="FormData.Ehliyet = $event"
                />
          </div>  -->
          <div class="col-md-6">
            <formcombobox
                  :FormDataType="FormDataType.Egitimseviyesi"
                  :Value="FormData.Egitimseviyesi"
                  :v="$v.FormData.Egitimseviyesi"
                  @input="FormData.Egitimseviyesi = $event"
                />
          </div>
          <div class="col-md-12">
            <forminput
              :FormDataType="FormDataType.Isilanlinki"
              :Value="FormData.Isilanlinki"
              :v="$v.FormData.Isilanlinki"
              @input="FormData.Isilanlinki = $event"
            />
          </div>
        </div>
        <div class="col-md-12">
            <formtextarea
                :FormDataType="FormDataType.Isintanimi"
                :Value="FormData.Isintanimi"
                :v="$v.FormData.Isintanimi"
                @input="FormData.Isintanimi = $event"
                />
          </div>
          <div class="col-md-12">
            <formtextarea
                :FormDataType="FormDataType.Aciklama"
                :Value="FormData.Aciklama"
                :v="$v.FormData.Aciklama"
                @input="FormData.Aciklama = $event"
                />
          </div>
          <div class="row">
            <div class="col-md-6">
                              <formdate :FormDataType="FormDataType.Yayinlanmatarihi" :Value="FormData.Yayinlanmatarihi"
                                :v="$v.FormData.Yayinlanmatarihi" @input="FormData.Yayinlanmatarihi = $event" />
            </div>
            <div class="col-md-6">
                              <formdate :FormDataType="FormDataType.Sonbasvurutarihi" :Value="FormData.Sonbasvurutarihi"
                                :v="$v.FormData.Sonbasvurutarihi" @input="FormData.Sonbasvurutarihi = $event" />
            </div>
          </div>
        <button class="btn btn-primary" type="submit">
          {{ $t("mznisilanlari.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
